import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Input, Spin } from 'antd';
import axios from "axios";
import { Switch } from 'antd';
import {USER_SERVER} from '../../../../config'
const { TextArea } = Input;

function TestChat116(props) {
    const render_ailist = props.ChatAIList && props.ChatAIList.map(function(ai, index){
        //console.log(ai);
        return (
    		<Button key={index} onClick={()=>props.onClickAI(ai.id)}>{ai.name} ({ai.count_history})</Button>
        );
		}
    );


    return (
        <div>
            <h3>TESTING Chat</h3> 

            <Row align='middle'>
                {render_ailist}
            </Row>
        </div>
    )
}

export default TestChat116
